<template>
  <div class="page-wrap">
    <!-- 工具栏（仅屏幕显示，打印时隐藏） -->
    <div class="toolbar no-print">
      <el-button @click="onExportPdf">导出PDF</el-button>
    </div>

    <div class="a4 landscape" ref="a4" >
      <h1 class="title">{{ year }}年度贵州省工程建设工法评审意见表</h1>

      <!-- 整体一个 table（横向 A4） -->
      <table class="big">
        <colgroup>
          <!-- 7列：分组竖排 + 左(类别/标准/结论) + 右(类别/标准/结论) -->
          <col style="width:14mm" />  <!-- 分组竖排 -->
          <col style="width:30mm" />  <!-- 左-类别 -->
          <col style="width:28mm" />  <!-- 左-标准 -->
          <col style="width:36mm" />  <!-- 左-结论 -->
          <col style="width:30mm" />  <!-- 右-类别 -->
          <col style="width:48mm" />  <!-- 右-标准 -->
          <col style="width:16mm" />  <!-- 右-结论 -->
        </colgroup>

        <!-- 顶部一行：工法名称 / 完成单位名称 / 主审人/复审人（同一行） -->
        <tr>
          <th class="kv-th" colspan="2">工法名称</th>
          <td class="kv-td" colspan="1">{{ safe(base.name) }}</td>
          <th class="kv-th">完成单位名称</th>
          <td class="kv-td" colspan="1">{{ safe(base.company) }}</td>
          <th class="kv-th">{{ zs == 1 ? '主审人' : '副审人' }}</th>
          <td class="kv-td" colspan="1">{{ safe(base.reviewers) }}</td>
        </tr>

        <!-- 以下三块与“审查人意见”统一为：左侧审查项、右侧审查结论的单行布局。 -->
        <!-- ================= 申报条件审查 ================= -->
        <tr>
          <td class="group" :rowspan="9" colspan="2"><div class="vwrap" style="writing-mode: horizontal-tb;">申报条件审查</div></td>
          <td class="cat" colspan="2">工法名称：内容与名称是否一致</td>
          <td class="std" colspan="3">{{ yn(normalizedForm.name_match.pass) }}</td>
        </tr>
        <tr><td class="cat" colspan="2">工法名称：是否与过去批准工法相同</td><td class="std" colspan="3">{{ yn(normalizedForm.history_match.pass) }}</td></tr>
        <tr><td class="cat" colspan="2">企业级工法审查：审查批准部门原件</td><td class="std" colspan="3">{{ text(normalizedForm.enterprise_approval_origin.comment) }}</td></tr>
        <tr><td class="cat" colspan="2">企业级工法审查：审查无争议证明</td><td class="std" colspan="3">{{ text(normalizedForm.enterprise_dispute.comment) }}</td></tr>
        <tr><td class="cat" colspan="2">工法主要完成单位及完成人审查</td><td class="std" colspan="3">{{ text(normalizedForm.main_units_members.comment) }}</td></tr>
        <tr><td class="cat" colspan="2">申报工法的工程应用实例审查</td><td class="std" colspan="3">{{ yn(normalizedForm.outside_province.pass) }}</td></tr>
        <tr><td class="cat" colspan="2">关键技术论证、鉴定证书审查，效益证明审查：鉴定（评估）或论证专家组是否满足有关要求</td><td class="std" colspan="3">{{ yn(normalizedForm.key_certificates_member.pass) }}</td></tr>
        <tr><td class="cat" colspan="2">关键技术论证、鉴定证书审查，效益证明审查：证书内容是否真实有效</td><td class="std" colspan="3">{{ yn(normalizedForm.key_certificates_cert.pass) }}</td></tr>
        <tr><td class="cat" colspan="2">关键技术论证、鉴定证书审查，效益证明审查：效益证明是否有效真实</td><td class="std" colspan="3">{{ yn(normalizedForm.key_certificates_xiaoyi.pass) }}</td></tr>

        <!-- ================= 工法文本审查 ================= -->
        <tr>
          <td class="group" :rowspan="3" colspan="2"><div class="vwrap" style="writing-mode: horizontal-tb;">工法文本审查</div></td>
          <td class="cat" colspan="2">工法名称与内容审查：名称与内容是否贴切，能否直观反映工法名称</td>
          <td class="std" colspan="3">{{ yn(normalizedForm.name_content_match.pass) }}</td>
        </tr>
        <tr><td class="cat" colspan="2">工法的叙述层次排列：工法是否按章、节、条款、项、层次排列</td><td class="std" colspan="3">{{ yn(normalizedForm.hierarchy_order.pass) }}</td></tr>
        <tr><td class="cat" colspan="2">工法中表格、插图审查：表格、图应有名称，图表应有文字描述及编号</td><td class="std" colspan="3">{{ yn(normalizedForm.table_figures.pass) }}</td></tr>

        <!-- ================= 编写内容审查 ================= -->
        <tr>
          <td class="group" :rowspan="8" colspan="2"><div class="vwrap" style="writing-mode: horizontal-tb;">编写内容审查</div></td>
          <td class="cat" colspan="2">工法特点审查：使用功能或施工方法上是否具备先进性、科学性、适用性、效益性、成熟型与应用性的特点</td>
          <td class="std" colspan="3">{{ text(normalizedForm.features.comment) }}</td>
        </tr>
        <tr><td class="cat" colspan="2">工法内容审查：材料与设备、质量安全、经济效益</td><td class="std" colspan="3">{{ text(normalizedForm.content_items.comment) }}</td></tr>
        <tr><td class="cat" colspan="2">适用范围审查：采用该工法的工程对象或工程部位</td><td class="std" colspan="3">{{ text(normalizedForm.scope.comment) }}</td></tr>
        <tr><td class="cat" colspan="2">环保节能审查：环保节能措施及效果</td><td class="std" colspan="3">{{ text(normalizedForm.environment.comment) }}</td></tr>
        <tr><td class="cat" colspan="2">工艺原理审查：关键技术基本原理是什么？特点是什么？其安全性可靠性？</td><td class="std" colspan="3">{{ text(normalizedForm.principle.comment) }}</td></tr>
        <tr><td class="cat" colspan="2">应用实例：工程名称、合同、鉴定或提供成熟可靠性证书</td><td class="std" colspan="3">{{ text(normalizedForm.cases.comment) }}</td></tr>
        <tr><td class="cat" colspan="2">工艺流程及操作要求审查：讲清基本工艺过程、工序衔接，工艺水平达到什么程度</td><td class="std" colspan="3">{{ text(normalizedForm.process_req.comment) }}</td></tr>
        <tr><td class="cat" colspan="2">关键技术证明（专利号、专利权人）：是否有关键技术证明</td><td class="std" colspan="3">{{ yn(normalizedForm.process_keypoints.pass) }}</td></tr>

        <!-- ================= 审查人意见 ================= -->
        <tr>
          <td class="group" :rowspan="4" colspan="2">
            <div class="vwrap" style="writing-mode: horizontal-tb;">审查人意见</div>
          </td>

          <td class="cat" colspan="2">1、工法关键技术水平？</td>
          <td class="std" colspan="3" style="white-space: normal; word-wrap: break-word;">
            {{ text(normalizedForm.key_tech_level.comment) }}
          </td>
        </tr>
        <tr>
          <td class="cat" colspan="2">2、是否适用于省内工程？</td>
          <td class="std" colspan="3">{{ yn(normalizedForm.suitable_in_province.pass) }}</td>
        </tr>
        <tr>
          <td class="cat" colspan="2">3、是否同意推荐为省级工法？</td>
          <td class="std" colspan="3">{{ yn(normalizedForm.recommend_provincial.pass) }}</td>
        </tr>
        <tr>
          <td class="cat red" colspan="2">不通过的充分理由（如同意可忽略）</td>
          <td class="std redbox" colspan="3">{{ text(normalizedForm.rejection_reason) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>

export default {
  name: 'GfReviewSingleTable',
  props: {
    year: { type: [String, Number], default: () => new Date().getFullYear() },
    base: {
      type: Object,
      default: () => ({
        name: '',        // 工法名称
        company: '',     // 完成单位名称
        reviewers: ''    // 主审人/复审人
      })
    },
    id:0,
    cid:0,
    zs:0,
    // 你的 form 结构（每项 {pass, comment}；rejection_reason 为字符串）
    form: { type: Object, required: true }
  },
  computed: {
    normalizedForm () {
      const defaults = {
        name_match: { pass: null, comment: '' },
        history_match: { pass: null, comment: '' },
        enterprise_approval_origin: { pass: null, comment: '' },
        enterprise_dispute: { pass: null, comment: '' },
        key_certificates_xiaoyi: { pass: null, comment: '' },
        key_certificates_cert: { pass: null, comment: '' },
        key_certificates_member: { pass: null, comment: '' },
        name_content_match: { pass: null, comment: '' },
        hierarchy_order: { pass: null, comment: '' },
        table_figures: { pass: null, comment: '' },
        features: { pass: null, comment: '' },
        content_items: { pass: null, comment: '' },
        scope: { pass: null, comment: '' },
        environment: { pass: null, comment: '' },
        cases: { pass: null, comment: '' },
        principle: { pass: null, comment: '' },
        process_req: { pass: null, comment: '' },
        process_keypoints: { pass: null, comment: '' },
        key_tech_level: { pass: null, comment: '' },
        suitable_in_province: { pass: null, comment: '' },
        recommend_provincial: { pass: null, comment: '' },
        rejection_reason: '',
      }
      const src = this.form && typeof this.form === 'object' ? this.form : {}
      const merged = Object.assign({}, defaults, src)
      Object.keys(defaults).forEach((key) => {
        if (key === 'rejection_reason') return
        const value = src[key]
        merged[key] = value && typeof value === 'object'
          ? Object.assign({}, defaults[key], value)
          : Object.assign({}, defaults[key])
      })
      merged.rejection_reason = src.rejection_reason != null ? src.rejection_reason : ''
      return merged
    },
  },
  methods: {
    onPrint () {
      window.print();
    },
    async onExportPdf () {
        let token = 'Bearer ' + localStorage.getItem('TOKEN');
        let url = `${window.location.protocol}//${window.location.host}/api/home/user/award_log/opinionexport/${this.id}?token=${token}&cid=${this.cid}`;
        
        window.open(url)
      
  },
    yn (v) {
      return v === true ? '是' : v === false ? '否' : '—';
    },
    text (v) {
      const s = (v == null ? '' : String(v)).trim();
      return s || '—';
    },
    safe (v) {
      const s = (v == null ? '' : String(v)).trim();
      return s || '—';
    }
  }
};
</script>

<style scoped>
/* 屏幕容器 */
.page-wrap { display: flex; flex-direction: column; align-items: center; gap: 10px; }

/* 工具栏（仅屏幕） */
.toolbar { width: 1200px; text-align: right; }

/* A4 页面与标题（横向） */
@page { size: A4 landscape; margin: 10mm; }
.a4 { width: 1200px; margin: 0 auto; color:#000; }
.title { text-align:center; font-weight:700; font-size:22px; margin: 4mm 0 6mm; }

/* 单一大表 */
.big { width:100%; border-collapse: collapse; table-layout: fixed; }
.big th, .big td {
  border: 1.4px solid #000;
  padding: 6px 8px;
  font-size: 13px;
  line-height: 1.45;
  vertical-align: middle;
  page-break-inside: avoid;  /* 打印避免拆行 */
}

/* 竖排分组 */
.group { text-align: center; }
.vwrap { writing-mode: vertical-rl; transform: rotate(0deg); font-weight:700; letter-spacing: 2px; }
.group.blank { background:#fff; border: 1.4px solid #000; }

/* 顶部一行“标题+值” */
.kv-th { text-align:center; font-weight:700; }
.kv-td { text-align:left; }
.twolines { white-space: normal; line-height: 1.1; }

/* 左右两栏 */
.cat { text-align:center; font-weight:700; }
.std { text-align:left; }
.res {
  text-align:center; font-weight:700;
  white-space: normal; word-wrap: break-word; word-break: break-all;
}
.blank { background:#fff; }

/* 审查人意见中的强调 */
.red { color:#b70000; }
.redbox { background:#fff1f1; }

/* 打印优化 */
@media print {
  .no-print { display: none !important; }
  .a4 { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}

/* 放在组件的 <style> *非 scoped* 中（或使用 :global / ::v-deep），避免被 html2pdf 克隆丢失 */
@media screen {
  .a4.landscape { width: 1123px; margin: 0 auto; } /* 297mm≈1123px@96dpi */
}

/* 只在打印/导出时生效 */
@media print {
  @page { size: A4 landscape; margin: 10mm; }
  .a4.landscape { width: 297mm; height: 210mm; }
  .no-print { display: none !important; }
  .a4 { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}

/* 也放在 *非 scoped* 的 <style>，或用 :deep(.a4) 包裹 */
.a4 .big { width:100%; border-collapse: collapse; table-layout: fixed; }
.a4 .big th, .a4 .big td {
  border: 1.4px solid #000;
  padding: 6px 8px;
  font-size: 13px;
  line-height: 1.45;
  vertical-align: middle;
  page-break-inside: avoid;
}
.a4 .kv-th { text-align:center; font-weight:700; }
.a4 .kv-td { text-align:left; }
.a4 .cat   { text-align:center; font-weight:700; }
.a4 .std   { text-align:left; }
.a4 .res   { text-align:center; font-weight:700; word-break: break-all; }
.a4 .red   { color:#b70000; }
.a4 .redbox{ background:#fff1f1; }

/* 竖排标题的兼容写法：先用 rotate 兜底，再优先 writing-mode */
.a4 .vwrap { transform: rotate(180deg); white-space: nowrap; display: inline-block; }
@supports (writing-mode: vertical-rl) {
  .a4 .vwrap { writing-mode: vertical-rl; transform: none; }
}

</style>
